var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.726,
    height: 15.421,
    viewBox: "0 0 38.726 15.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-arrow-right-thin",
    d: "M21.883,12l-7.527,6.235L15,19l9-7.521L15,4l-.645.764L21.884,11H-14.342v1H21.883Z",
    transform: "translate(14.492 -3.789)",
    fill: "#333",
    stroke: "#333",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrow);
export default __webpack_public_path__ + "static/media/long-arrow.e7b8e089ffd6d0bc2f8cff5c9e8ce989.svg";
export { ForwardRef as ReactComponent };